module.exports = __webpack_public_path__ + "img/logoOaxacabg.2090a1da.png";